<nav class="navbar navbar-expand-lg d-none d-lg-flex shadow navbar-light bg-light">
    <div class="container-fluid">
        <a class="navbar-brand" [routerLink]="['/welcome']">
            <!-- <img [src]="imagesUrl+'header-logo.png'" width="100" height="26" alt="Zorbek"> -->
        </a>
        <div class="collapse navbar-collapse">
            <ul class="navbar-nav w-100 mb-2 mb-lg-0">
                <li class="nav-item">
                    <a class="nav-link" routerLinkActive="active" [routerLink]="['/welcome']">Bienvenida</a>
                </li>
                <li class="nav-item ms-auto">
                    <a class="nav-link" routerLinkActive="active" [routerLink]="['/login']">Iniciar Sesión/Registro</a>
                </li>
            </ul>
        </div>
    </div>
</nav>

<nav class="navbar navbar-expand-lg d-flex d-lg-none shadow navbar-light bg-light">
    <div class="container-fluid">
        <a class="navbar-brand" [routerLink]="['/welcome']">
            <!-- <img [src]="imagesUrl+'header-logo.png'" width="100" height="26" alt="Zorbek"> -->
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav w-100 mb-2 mb-lg-0">
                <li class="nav-item">
                    <a class="nav-link" routerLinkActive="active" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" [routerLink]="['/welcome']">Bienvenida</a>
                </li>
                <li class="nav-item ms-auto">
                    <a class="nav-link" routerLinkActive="active" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" [routerLink]="['/login']">Iniciar Sesión/Registro</a>
                </li>
            </ul>
        </div>
    </div>
</nav>